module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"sku-map-deleted":"SKU map deleted","failed-delete-sku-map":"Failed to delete SKU map"}}')
  delete Component.options._Ctor
}
